import { Box, Flex, Grid, media, xcss } from '@atlaskit/primitives';
import React from 'react';

type PageSectionProps = {
	children: React.ReactNode;
};

const pageStyles = xcss({
	paddingRight: 'space.300',
	paddingLeft: 'space.300',
});

const responsiveStyles = xcss({
	[media.above.lg]: {
		width: '1200px',
	},
	marginLeft: 'auto',
	marginRight: 'auto',
	gap: 'space.250',
});

export const PageSection = ({ children }: PageSectionProps) => {
	return (
		<Grid alignItems="center" xcss={responsiveStyles}>
			<Flex alignItems="center" justifyContent="center">
				<Box xcss={pageStyles}>{children}</Box>
			</Flex>
		</Grid>
	);
};
